import { render, staticRenderFns } from "./BulkMovingList.vue?vue&type=template&id=5623b0ce&scoped=true&"
import script from "./BulkMovingList.vue?vue&type=script&lang=js&"
export * from "./BulkMovingList.vue?vue&type=script&lang=js&"
import style0 from "./BulkMovingList.vue?vue&type=style&index=0&id=5623b0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5623b0ce",
  null
  
)

export default component.exports